module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep6_The_endangered_foods_list_Mobile.234bdd21.jpg";